<template>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Arbeitsfläche Mast > Allgemeine Punkte</div>
        <div class="text-xl md:text-xl font-bold">Arbeitsfläche Mast</div>
        <div class="content h-full max-h-full">
<!-- Allgemeine Punkte Start-->
          <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
            <div class="text-lg md:text-lg col-span-8">Allgemeine Punkte</div>
            <div class="col-span-3 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Frage</div>
            <div class="text-sm font-bold col-span-5 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
<!-- Flaechengroesse start-->
            <div class="text-xs col-span-3">Größe der Arbeitsfläche ist</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist'
                )?.['eingabeText']
                  ? useIdentifierFrageFinder(
                      ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist'
                    )?.['eingabeText'] + " m²"
                  : "-"
              }}
            </div> 
            <div class="text-xs col-span-3">Größe der Arbeitsfläche soll</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-soll'
                )?.['eingabeText'] 
                  ? useIdentifierFrageFinder(
                      ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-soll'
                    )?.['eingabeText'] + " m²"
                  : "-"
              }}
            </div>
            <div class="text-xs col-span-3">Größe der Arbeitsfläche ist-soll</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist-soll'
                )?.['eingabeText'] 
                  ? useIdentifierFrageFinder(
                      ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist-soll'
                    )?.['eingabeText'] + " m²"
                  : "-"
              }}
            </div>


<!-- Flaechengroesse Ende-->
<!-- Arbeitsflächengrenze start-->
            <div class="text-xs col-span-3 mt-2">Abst. Arbeitsflächengrenze ist</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist'
                )?.['eingabeText'] 
                  ? useIdentifierFrageFinder(
                      ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist'
                    )?.['eingabeText'] + " m"
                  : "-"
              }}
            </div>

            <div class="text-xs col-span-3">Abst. Arbeitsflächengrenze soll</div>

            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-soll'
                )?.['eingabeText'] 
                  ? useIdentifierFrageFinder(
                      ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-soll'
                    )?.['eingabeText'] + " m"
                  : "-"
              }}
            </div>

            <div class="text-xs col-span-3">Abst. Arbeitsflächengrenze ist-soll</div>

            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist-soll'
                )?.['eingabeText'] 
                  ? useIdentifierFrageFinder(
                      ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist-soll'
                    )?.['eingabeText'] + " m"
                  : "-"
              }}
            </div>

<!-- Arbeitsflächengrenze Ende-->
<!-- Allgemeine Punkte start-->
            <div class="mt-4 text-lg md:text-lg col-span-8">Allgemeine Bilder Arbeitsfläche</div>
            <div class="col-span-8 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"></div>
            <oneto-five-image-div
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.allgemein-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Analyse</div>
            <div class="text-sm font-bold col-span-5 border-solid rounded-md whiteYellowBorderColor">Analyseergebnisse</div>
            <div class="col-span-1 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>
<!-- Fremdobjekte start-->
            <div class="text-xs col-span-2">Fremdobjekte auf Fläche:</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{
                useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.fremdobjekte-auf-flaeche'
                )?.['eingabeText']
              }}
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.fremdobjekte-auf-flaeche-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Fremdobjekte Ende-->
            <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.weitere-fremdobjekte-auf-flaeche" label="Weitere Fremdobjekte" class="col-span-2"/>
            <div class="text-xs text-gray-500 col-span-6">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText'] }}
            </div>
            <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.betreiber-vorhanden" label="Betreiber Fremdobjekte" class="col-span-2"/>
            <div class="text-xs text-gray-500 col-span-6">
              {{ getAuswahlLabel(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.betreiber') }}
            </div>
<!-- Flurstuecke start-->
            <div class="text-xs col-span-2">Betroffene Flurstücke</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.betroffeneflurstuecke')?.['eingabeText'] }}
            </div>
<!-- Flurstuecke Ende-->
<!-- Nutzungsart start-->
            <div class="text-xs col-span-2">Nutzungsarten der Fläche:</div>
            <div class="text-xs text-gray-500 col-span-5">
              <ul v-for="(v, key) in useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.nutzungsart-der-flaeche')?.getSelectedAuswahlLabels()"
                :key="key"
              >
                <li :key="key" class="text-xs text-gray-500">{{ v.de }}</li>
              </ul>
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.nutzungsart-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Nutzungsart Ende-->
          </div>
<!-- Allgemeine Punkte Ende-->
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Arbeitsfläche Mast > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung/Graben)</div>
        <div class="content h-full max-h-full">
            <div class="mt-4 text-lg md:text-lg">Geländebeschaffenheit</div>
            <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Frage</div>
              <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Beschreibung/Eingabewerte</div>
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Weitere Eingaben</div>
              <div class="col-span- text-sm font-bold"  style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Bewertung</div>
<!-- Gefälle start-->
            <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-vorhanden" label="Gefälle/Hang/Böschung" class="col-span-2"/>
            <div class="text-xs text-gray-500 col-span-3">
              {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              <ul
                v-for="(v, key) in useIdentifierFrageFinder(
                  ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-boeschung-art'
                )?.getSelectedAuswahlLabels()"
                :key="key"
              >
                <li :key="key" class="text-xs text-gray-500">{{ v.de }}</li>
              </ul>
            </div>
            <bewertung-chip
              fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
<!-- Gefälle Ende-->
<!-- Ausholzung start-->
              <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-erforderlich" label="Ausholzung erforderlich" class="col-span-2"/>
              <div class="text-xs text-gray-500 col-span-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-beschreibung')?.['eingabeText'] }}
              </div>
              <div class="text-xs">Art:</div>
              <div class="text-xs text-gray-500">
                {{ getAuswahlLabel(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-art') }}  
              </div>
              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Ausholzung Ende-->

<!-- Rodung Start-->
              <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-erforderlich"
                label="Rodung erforderlich"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-beschreibung')?.['eingabeText'] }}
              </div>
              <div class="text-xs">Anzahl Bäume:</div>
              <div class="text-xs text-gray-500">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-anzahl-baeume')?.['eingabeText'] }}
              </div>

              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />

              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Rodung Ende-->

<!-- Graben Start-->
              <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-vorhanden"
                label="Graben vorhanden"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-beschreibung')?.['eingabeText'] }}
              </div>
              <div class="text-xs">Anzahl:</div>
              <div class="text-xs text-gray-500">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-anzahl')?.['eingabeText'] }}
              </div>
              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />

              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Graben Ende -->
            </div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page> 
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height:1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Arbeitsfläche Mast > Geländebeschaffenheit (Feuchtgebiete/Naturdenkmäler/Kampfmittel/Sonstiges)</div>
        <div class="content h-full max-h-full">
          <div class="mt-4 text-lg md:text-lg">Geländebeschaffenheit - Fortsetzung</div>
          <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Frage</div>
              <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Beschreibung/Eingabewerte</div>
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Weitere Eingaben</div>
              <div class="col-span- text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Bewertung</div>
<!-- Feuchtgebiete Start-->
              <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-vorhanden"
                label="Feuchtgebiete vorhanden"
                class="col-span-2 "
              />
              <div class="text-xs text-gray-500 col-span-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-beschreibung')?.['eingabeText'] }}
              </div>
              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="col-span-3 justify-self-end"
              />
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Feuchtgebiete Ende-->
<!-- Naturdenkmaeler Start-->
              <div class="col-span-3">
                <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-vorhanden"
                label="Naturdenkmäler vorhanden"
                class="col-span-2"
                />
                <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.weitere-naturdenkmaeler-sichtbar"
                label="Weitere Naturdenkmäler sichtbar"
                class="col-span-2"
                />
              </div>
              <div class="text-xs text-gray-500 col-span-4">
                {{ useIdentifierFrageFinder(ba,'tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-beschreibung')?.['eingabeText'] }}
              </div>
              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Naturdenkmaeler Ende-->
<!-- Kampfmittel Start-->
              <div class="col-span-2">
                <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-vorhanden"
                label="Kampfmittel vorhanden"
                class="col-span-2 "
                />
                <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-freimessung"
                label="Freimessung erforderlich"
                class="col-span-1 "
                />
              </div>
              <div class="text-xs text-gray-500 col-span-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-beschreibung')?.['eingabeText'] }}
              </div>
              <div class="text-xs">Art:</div>
              <div class="text-xs text-gray-500"> 
                {{ useIdentifierFrageFinder(ba,'tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-art')?.['eingabeText'] }}
              </div>
              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class=" justify-self-end"
              />
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Kampfmittel Ende-->
<!-- Sonstiges Start -->
              <is-vorhanden-char-and-label
                :ba="ba"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-vorhanden"
                label="Sonstiges vorhanden"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-5">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-beschreibung')?.['eingabeText'] }}
              </div>
              <bewertung-chip
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                fragesPath="tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-bilder"
                :lang="lang"
                class="col-span-8"
              />
<!-- Kampfmittel Ende-->
          </div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>
  <Oekologie :ba="ba" :immobilie="immobilie" :lang="lang" :oekologie="ba.findFragenblockByRelativePath('arbeitsflaeche-mast-tab.oekologie-group')!" bread-crumb="Arbeitsfläche Mast > Ökologie" tab="Arbeitsfläche"/>

</template>

<script lang="ts">
  import useUser from '@/composables/useUser';
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import Immobilie, { immobilie } from '@/models/immobilie.model';
  import { defineComponent, PropType } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { getAuswahlLabel, useIdentifierFrageFinder } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
  import { getPhotoUrl } from '@/utilities/get-media-url';
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import UniversalPdfImageRow from '../Components/UniversalPdfImageRow.vue';
  import PdfChip from '../Components/PdfChip.vue';
  import TngHeader from './PageElements/TngHeader.vue';
  import BeFooter from './PageElements/BeFooter.vue';
  import OnetoFiveImageDiv from './PageElements/OnetoFiveImageDiv.vue';
  import BewertungChip from './PageElements/BewertungChip.vue';
  import Oekologie from './PageElements/Oekologie.vue';
  import isVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabel.vue';

  export default defineComponent({
    name: 'Arbeitsflaeche',
    components: {
      PdfA4Page,
      PdfChip,
      UniversalPdfImageRow,
      TngHeader,
      BeFooter,
      OnetoFiveImageDiv,
      BewertungChip,
      Oekologie,
      isVorhandenCharAndLabel,
    },
    props: {
      ba: {
        type: Object as PropType<Bestandsaufnahme>,
        required: true,
      },
      immobilie: {
        type: Object as PropType<Immobilie>,
        required: true,
      },
      lang: {
        type: String,
        default: 'de',
      },
    },
    setup(props: any) {
      const { t } = useI18n({ useScope: 'global' });
      const uUser = useUser();

      return {
        user: uUser.user,
        t,
        useIdentifierFrageFinder,
        moment,
        getPhotoUrl,
        getAuswahlLabel
      };
    },
  });
</script>
<style scoped>
  * {
    color: rgb(23, 68, 81);
    font-family: var(--secondaryFont);
  }
  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: var(--white100);
  }
  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: black;
  }
  .trenner {
    height: 1px;
    border-width: 0;
    color: gray;
    background-color: gray;
  }
  .content {
    height: 870px;
  }
</style>